<template>
  <footer class="footer-entry">
    <div class="container">
      <div class="flex">
        <div class="copy order2">
          COPYRIGHT © au FINANCIAL SERVICE CORPORATION,
          <span class="-spblock">ALL RIGHTS RESERVED.</span>
        </div>
        <div class="corp order1">
          <div class="name">auフィナンシャルサービス株式会社</div>
          <div>
            登録番号：関東財務局長（1）&nbsp;第01532号
            <span class="-spblock"
              >協会員番号&nbsp;日本貸金業協会会員&nbsp;第006420号</span
            >
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterEntry",
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.footer-entry {
  border-top: 1px solid $secondary;
  margin-top: 30px;
  padding: 30px 0;
  @include mq-down(md) {
    margin-top: 15px;
    padding-top: 15px;
    padding-bottom: 10px;
  }
  .flex {
    @include flex(flex, space-between, center, row, nowrap);
    @include mq-down(md) {
      flex-direction: column;
    }
    .order1 {
      @include mq-down(md) {
        order: 1;
      }
    }
    .order2 {
      @include mq-down(md) {
        order: 2;
      }
    }
    .copy {
      font-size: 12px;
      text-align: center;
      @include mq-down(md) {
        margin-bottom: 10px;
      }
      @include mq-up(md) {
        text-align: right;
      }
    }
    .corp {
      font-size: 12px;
      text-align: center;
      @include mq-down(md) {
        margin-bottom: 10px;
      }
      @include mq-up(md) {
        text-align: right;
        line-height: 20px;
      }
      .name {
        font-size: 14px;
        @include mq-down(md) {
          margin-bottom: 10px;
        }
      }
    }
    .-spblock {
      @include mq-down(md) {
        display: block;
      }
    }
  }
}
</style>
